import React from 'react';
import PropTypes from 'prop-types';
import { defaultStyles } from 'utils/Theme';
import { qlikClient } from 'constants/environmental';
import config from 'coeus.config';
import QvrfComponent from 'components/common/Qlik/QvrfComponent';
import QvrfContainer from 'components/qvrf_component/QvrfContainer';

const SAAS = config.saas_client === qlikClient.SAAS;

const QlikHeaderBookmarks = ({ qsOptions }) => {
    const classes = defaultStyles();

    return (
        <QvrfContainer config={qsOptions.config} loaderHeight={450}>
            <QvrfComponent
                props={{
                    type: 'qAppBookmark',
                    title: 'Bookmarks',
                    height: '98vh',
                }}
                type={'qAppBookmark'}
                options={qsOptions}
            />
        </QvrfContainer>
    );
};

QlikHeaderBookmarks.propTypes = {
    qsOptions: PropTypes.object,
};

export default QlikHeaderBookmarks;
